import React, { FC } from 'react'

const SmallFireIcon: FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_40006009_51466)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0124 1.69186C12.2791 1.4971 12.624 1.44706 12.9346 1.55808C14.3086 2.04925 16.2997 3.56377 17.9315 5.59494C19.5801 7.64704 21 10.3959 21 13.4459C21 15.6722 20.2634 17.9315 18.7474 19.6473C17.215 21.3816 14.938 22.5 12 22.5C9.06198 22.5 6.78498 21.3816 5.25259 19.6473C3.73656 17.9315 3 15.6722 3 13.4459C3 10.4944 4.32996 7.82528 5.90713 5.79898C6.11426 5.53287 6.44038 5.38917 6.77525 5.41648C7.11012 5.44378 7.40899 5.63842 7.57082 5.93462C7.84488 6.43622 8.15012 6.90388 8.38981 7.24936L8.43533 7.31464C8.60097 7.25018 8.79229 7.14943 9.00629 7.00145C9.43411 6.70563 9.87984 6.27019 10.2844 5.74521C11.1196 4.66135 11.623 3.40808 11.6001 2.53248C11.5914 2.20105 11.7456 1.8866 12.0124 1.69186ZM12.7678 12.0178C13.0356 11.8922 13.345 11.8922 13.6129 12.0178C14.1479 12.2687 14.6322 12.7361 15.0118 13.2452C15.4031 13.7701 15.7436 14.4196 15.9473 15.1254C16.3582 16.5496 16.2278 18.3476 14.6272 19.6188C13.716 20.3424 12.5278 20.5905 11.4557 20.4512C10.3842 20.3118 9.28557 19.7626 8.66783 18.7127C8.15784 17.8459 8.10233 16.9539 8.3551 16.1361C8.59505 15.3598 9.09529 14.6988 9.62026 14.1708C10.6683 13.1166 12.0611 12.3493 12.7678 12.0178Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_40006009_51466">
        <rect width="24" height="24" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
)

export default SmallFireIcon
